"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.XIcon24Solid = forwardRef_1.forwardRef('XIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M3.94 3.94a1.5 1.5 0 0 1 2.12 0L12 9.878l5.94-5.94a1.5 1.5 0 0 1 2.12 2.122L14.122 12l5.94 5.94a1.5 1.5 0 0 1-2.122 2.12L12 14.122l-5.94 5.94a1.5 1.5 0 0 1-2.12-2.122L9.878 12l-5.94-5.94a1.5 1.5 0 0 1 0-2.12Z" })));
});
